export class EditorConfiguration {
  public BoldButton = false;
  public ItalicButton = false;
  public UnderlineButton = false;
  public StrikethroughButton = false;

  public AlignLeftButton = false;
  public AlignCenterButton = false;
  public AlignRightButton = false;
  public AlignJustifyButton = false;

  public InsertUnorderedListButton = false;
  public InsertOrderedListButton = false;
  public IndentButton = false;
  public OutdentButton = false;

  public SubscriptButton = false;
  public SuperscriptButton = false;

  public FormatList = false;
  public CleanFormattingButton = false;

  public FontFamilyList = false;
  public FontSizeList = false;

  public ForeColorPicker = false;
  public BackColorPicker = false;

  public InsertTableButton = false;

  public AddColumnBeforeButton = false;
  public AddColumnAfterButton = false;
  public AddRowBeforeButton = false;
  public AddRowAfterButton = false;
  public DeleteColumnButton = false;
  public DeleteRowButton = false;
}
